import React, {Component} from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Grid, } from '@material-ui/core'
import moment from 'moment'

import CardWrapper from '../../../../../components/Cards/CardWrapper/CardWrapper'
import SimpleLoader from '../../../../../components/Loaders/SimpleLoader'
import {ErrorMessage} from '../../../../../components/DisplayData/DisplayData'
import {RoundedButton} from '../../../../../components/Buttons/GeneralButtons'
import ProfileAvatar from '../../../../../components/Avatars/ProfileAvatar'

import {formData} from './data'
import {contentData} from './content'
import LineInputText from '../../../../../components/Inputs/LineInputText/LineInputText';
import LineInputSelect from '../../../../../components/Inputs/LineInputSelect/LineInputSelect';
import ContentText from '../../../../../components/Texts/ContentText';
import { USER_TYPE } from '../../../../../variables/config'

const styles = (theme) => ({
  root:{padding:'32px'}
})



class EditBasicInfo extends Component {

  state = {
    form: JSON.parse(JSON.stringify(formData)),
    accredited:false,
    isValid:false
  }

  render(){

    const {classes, language, issending, error, onChangeImage, user} = this.props
    const {form, isValid} = this.state
    const content = contentData[language]

    let tempForm = {...form}
    let loaderContent = null
    if(issending){
      loaderContent = <SimpleLoader />
    }else{
      if(error){
        loaderContent = <ErrorMessage message={error}/>
      }
    }


    let avatarContent = null
    avatarContent = <ProfileAvatar image={user ? user.image : null}/>
    
    
    const isHospitalAdmin = tempForm && tempForm.user_type_id.value === 5

    let agencyContent = null
    //console.log(tempForm.user_type_id)
    if(tempForm.user_type_id.value === USER_TYPE.MERCURIO){
      agencyContent = <Grid item xs={12} md={6}>
          <LineInputSelect
            data={tempForm.agency_id}
            onChange={this.onInputChange}
          />
        </Grid>
    }

    

    return(
      <CardWrapper>
        <div className={classes.root}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Grid container spacing={2} direction='column' justifyContent='center' alignItems='center'>
                <Grid item>{avatarContent}</Grid>
                <Grid item>
                  <RoundedButton 
                    label={content.image_button}
                    size='small'
                    color='secondary'
                    onClick={onChangeImage}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ContentText text='Informacion del asesor' variant='bold' medium/>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.first_name}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.last_name}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.username}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.email}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.mobile}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.phone}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.ext}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputSelect
                        data={tempForm.user_type_id}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    {agencyContent}
                    {isHospitalAdmin ? (
                      <Grid item xs={12} md={6}>
                        <LineInputSelect
                          data={tempForm.hospital_id}
                          onChange={this.onInputChange}
                        />
                      </Grid>
                    ) : null}
                    <Grid item xs={12} md={6}>
                      <LineInputSelect
                        data={tempForm.gender_id}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputSelect
                        data={tempForm.timezone}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputSelect
                        data={tempForm.status}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            
            <Grid item xs={12}>
              <Grid container justifyContent='flex-end' alignItems='center' spacing={2}>
                <Grid item>
                  {loaderContent}
                </Grid>
                <Grid item>
                  <RoundedButton 
                    label={content.add_button} 
                    size='small' 
                    disabled={!isValid}
                    onClick={this.onSubmit}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </CardWrapper>
    )
  }

  componentDidMount(){
    const {language, catalogs, user, hospitals} = this.props
    const {form} = this.state
    const content = contentData[language]
    let tempA = {...form}
    tempA.user_type_id.options = [...catalogs.user_types]
    tempA.agency_id.options = [...catalogs.agencies]
    tempA.gender_id.options = [...catalogs.user_genders]
    tempA.timezone.options = [...catalogs.timezones]
    tempA.status.options = [...catalogs.user_statuses]
    tempA.hospital_id.options = [...hospitals]

    Object.keys(form).forEach(item => {
      if(user){
        let value = user[item];
        if(tempA[item].config.type === 'date'){
          value = value ? moment(value).format('YYYY-MM-DD') : null;
        }
        tempA[item].value = value !== undefined && value !==null ? value : '';
        tempA[item].isValid = value ? true : false;
      }
      tempA[item].config = {...tempA[item].config,...content.form[item]}
    })
    const isValidForm = this.validationForm(tempA);
    console.log(tempA.status)
    this.setState({form:{...tempA}, isValid: isValidForm})
  }

  onInputChange = (data) => {
    const {form} = this.state
    const id = data.config.id;
    let temp = {...form};
    temp[id] = {...data};
    const isValidForm = this.validationForm(temp)
    this.setState({form:{...temp}, isValid:isValidForm})
  }

  validationForm = (data) => {
    let isValid = true;
    Object.keys(data).forEach((item) => {
      if(data[item].isRequired && !data[item].isValid){
        isValid = false;
      }
    })
    return isValid;
  }

  onSubmit = () => {
    const {onSubmit, user} = this.props
    const {form} = this.state
    let data2Send = {}
    
    Object.keys(form).forEach((item)=>{
      if(form[item].isValid){
        if(form[item].value !== user[item]){
          data2Send = {...data2Send, [item]:form[item].value}
        }
      }
    })

    if(data2Send.user_type_id !== USER_TYPE.MERCURIO) data2Send.agency_id = undefined
    
    onSubmit(data2Send)
  }

  onChangeCheckbox = (id, status) => {
    this.setState({[id]:status})
  }
}

export default withStyles(styles)(EditBasicInfo)